// extracted by mini-css-extract-plugin
export var input = "Textarea-module--input--82e8d";
export var label = "Textarea-module--label--bb6a4";